import React, { useEffect, useState } from 'react';
import { BellIcon, ArrowLeftIcon, MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import api from '../axios';

function Header({ pageTitle }) {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("theme") === "dark");

  const isAdmin = sessionStorage.getItem("isAdmin") === "true";
  const userId = sessionStorage.getItem("userId");

  useEffect(() => {
    const root = window.document.documentElement;
    if (darkMode) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = isAdmin
          ? await api.get("/api/notification")
          : await api.get(`/api/notification/user/${userId}`);
        setNotifications(res.data);
      } catch (err) {
        console.error("Bildirimler alınamadı:", err);
      }
    };
    fetchNotifications();
  }, [isAdmin, userId]);

  const handleMarkAsRead = async (id) => {
    try {
      await api.patch(`/api/notification/${id}/read`);
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, isRead: true } : n))
      );
    } catch (err) {
      console.error("Okundu olarak işaretlenemedi:", err);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  const unreadCount = notifications.filter((n) => !n.isRead).length;

  const formatDate = (iso) => {
    const date = new Date(iso);
    return date.toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    });
  };

  return (
    <header className="flex items-center justify-between px-4 py-3 bg-white dark:bg-gray-800 shadow relative">
      <h1 className="text-xl font-semibold text-gray-800 dark:text-gray-100">{pageTitle}</h1>

      <div className="flex items-center space-x-4">
        

        {/* Bildirim butonu */}
        <div className="relative">
          <button
            type="button"
            onClick={() => setShowNotifications(!showNotifications)}
            className="p-2 text-gray-600 dark:text-gray-300 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 relative"
            aria-label="Bildirimler"
          >
            <BellIcon className="w-6 h-6" />
            {unreadCount > 0 && (
              <span className="absolute top-0 right-0 bg-red-500 text-white text-xs px-1 rounded-full">
                {unreadCount}
              </span>
            )}
          </button>

          {showNotifications && (
            <div className="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 shadow-lg rounded-md overflow-hidden z-50">
              {notifications.length > 0 ? (
                notifications.map((notification) => (
                  <div
                    key={notification.id}
                    onClick={() => handleMarkAsRead(notification.id)}
                    className={`px-4 py-2 cursor-pointer border-b text-sm ${
                      notification.isRead
                        ? "text-gray-500 dark:text-gray-400"
                        : "font-semibold text-gray-800 dark:text-white"
                    } hover:bg-gray-100 dark:hover:bg-gray-700`}
                  >
                    <div>{notification.message}</div>
                    <div className="text-xs mt-1 text-gray-400">
                      {formatDate(notification.createdAt)}
                    </div>
                  </div>
                ))
              ) : (
                <div className="px-4 py-2 text-sm text-gray-500">Hiç bildiriminiz yok.</div>
              )}
            </div>
          )}
        </div>

        {/* Çıkış butonu */}
        <button
          type="button"
          onClick={handleLogout}
          className="p-2 rounded-full text-red-500 hover:bg-red-100 dark:hover:bg-red-900"
          aria-label="Çıkış Yap"
        >
          <ArrowLeftIcon className="w-6 h-6" />
        </button>
      </div>
    </header>
  );
}

export default Header;
